module.exports = __webpack_public_path__ + "img/充电桩.55ff4ffd.png";